import * as React from "react";
const SvgArrowRightSmall20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 7,
        height: 10,
        fill: "black",
        viewBox: "0 0 7 10"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m.586 8 3-3-3-3L2 .586 6.414 5 2 9.414.586 8Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowRightSmall20Px;
